import { Modal, Button } from "semantic-ui-react";

import "./WarningModal.css";

interface IProps {
    modalOpen: boolean;
    setModalOpen: (value: boolean) => void;
    warningText: string;
    confirmAction: () => void;
    declineAction?: () => void;
}

export const WarningModal = ({
    modalOpen,
    setModalOpen,
    declineAction,
    warningText,
    confirmAction,
}: IProps) => {
    return (
        <Modal className="warning-modal" open={modalOpen} onClose={() => setModalOpen(false)}>
            <Modal.Header>Warning!</Modal.Header>
            <Modal.Content>
                <p>{warningText}</p>
            </Modal.Content>

            <Modal.Actions>
                <Button
                    content="No"
                    onClick={() => {
                        setModalOpen(false);
                        if (declineAction) {
                            declineAction();
                        }
                    }}
                />
                <Button content="Yes" onClick={() => confirmAction()} />
            </Modal.Actions>
        </Modal>
    );
};
